/**
 * ChannelsOverviewCard — Channels preview or empty state for overview tab.
 */

import { useTranslation } from 'react-i18next';
import { Wifi } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent, Button } from '@/components/v2/ui';
import { EID } from '@/lib/element-ids.registry';

interface ChannelsOverviewCardProps {
  channelCount: number;
  onViewChannels: () => void;
  onAddChannel: () => void;
}

export function ChannelsOverviewCard({ channelCount, onViewChannels, onAddChannel }: ChannelsOverviewCardProps) {
  const { t } = useTranslation();

  return (
    <Card className="product-overview-channels overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between px-6 py-5 border-b border-neutral-100 dark:border-neutral-800">
        <CardTitle className="text-base">{t('products.overview.channels')}</CardTitle>
        {channelCount > 0 && (
          <button id={EID['product-overview-view-channels-link']} onClick={onViewChannels} className="text-sm text-green-600 dark:text-green-400 hover:text-green-700 font-medium">
            {t('products.overview.viewAll')} &rarr;
          </button>
        )}
      </CardHeader>
      <CardContent className="p-8">
        <div className="text-center py-10">
          <div className="w-14 h-14 rounded-2xl bg-neutral-50 dark:bg-neutral-800 flex items-center justify-center mx-auto mb-4">
            <Wifi className="w-7 h-7 text-neutral-300 dark:text-neutral-600" />
          </div>
          <p className="text-sm font-medium text-neutral-900 dark:text-neutral-50 mb-1.5">
            {t('products.overview.noChannels')}
          </p>
          <p className="text-xs text-neutral-500 dark:text-neutral-400 mb-5">
            {t('products.overview.noChannelsHint')}
          </p>
          <Button id={EID['product-overview-add-channel-btn']} variant="primary" size="sm" onClick={onAddChannel}>
            {t('products.overview.addChannel')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
